import { defaults } from '../util';

const defaultOptions = {
  scope: global.window
};

export function error(event, analytics) {
  let trace;
  let errorObj = {};
  if (event) {
    if (event.error && event.error.stack) {
      trace = event.error.stack.substring(0, 150);
    }
    errorObj = {
      message: event.message,
      file: event.filename,
      lineNumber: event.lineno,
      columnNumber: event.colno,
      stackTrace: trace,
      sourceType: 'javascript'
    };
    analytics.error(errorObj);
  }
}

export class ErrorMonitor {
  constructor(options = {}) {
    this.options = defaults(options, defaultOptions);
  }

  monitor(analytics) {
    this.options.scope.addEventListener('error', function handle(event) {
      error(event, analytics);
    });
  }
}
